import UIkit from 'uikit'
import "../styles/uikit.less"
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);

import "../styles/banner.css"

import { SIGN_OUT, SIGN_IN } from "../globals/events.js"

export function signOut() {
  var auth2 = gapi.auth2.getAuthInstance();
  auth2.signOut().then(function () {
    document.getElementById("profile-pic").src = "https://via.placeholder.com/30/30";
    window.ID.user = undefined;
    document.dispatchEvent(new Event(SIGN_OUT));
  });
}
function onSignIn(googleUser) {
  var profile = googleUser.getBasicProfile();
  // console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
  // console.log('Name: ' + profile.getName());
  // console.log('Image URL: ' + profile.getImageUrl());
  // console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
  // console.log('AuthToken: ' + googleUser.getAuthResponse().id_token);
  document.getElementById("profile-pic").src = profile.getImageUrl();
  
  window.ID.user = googleUser;
  document.dispatchEvent(new Event(SIGN_IN));
}
function signInFailed(evt) {
  console.error(evt);
}
export function renderSignIn() {
  gapi.signin2.render('sign-in-btn', {
    'scope': 'profile email',
    'width': 100,
    'height': 30,
    'longtitle': false,
    'theme': 'dark',
    'onsuccess': onSignIn,
    'onfailure': signInFailed
  });
}
